export const formatTimestamp = (timestamp: number) => {
  const date = new Date(timestamp);
  const formatter = new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  return formatter.format(date);
};

export const nowWithSeconds = (nbOfSeconds: number) => {
  const now = new Date();
  now.setSeconds(nbOfSeconds);
  return now.getTime() / 1000;
};
